import { FullScreenSpinner } from 'smoothie';

import { useGetApexAccounts } from '../hooks/useGetApexAccounts';
import { InvestmentsOverview } from './InvestmentsOverview';
import { InvestmentsSplash } from './InvestmentsSplash';

export const Investments = () => {
    const {
        isFetching,
        data: apexAccounts,
        dataUpdatedAt,
    } = useGetApexAccounts();
    if (isFetching) {
        return <FullScreenSpinner />;
    }
    if (!apexAccounts || apexAccounts.length === 0) {
        return <InvestmentsSplash />;
    } else {
        return (
            <InvestmentsOverview
                imAccounts={apexAccounts}
                dataUpdatedAt={dataUpdatedAt}
            />
        );
    }
};
